module.exports = __webpack_public_path__ + "img/clear-button.232ce14c.svg";